import { useGetUsers } from '../api/useGetUsers';
import { SummaryCard } from './SummaryCard';

export const GuestsTotalCard = () => {
  const { data, isLoading } = useGetUsers({ page: 0, limit: 1 });
  const total = data?.payload?.total ?? 0;

  return (
    <div className="flex gap-4">
      <SummaryCard label="Total Members" value={total.toLocaleString()} loading={isLoading} />
    </div>
  );
};
